import { plural } from '@/utils/useText'
import * as amplitude from '@amplitude/analytics-browser'

export default defineNuxtPlugin(nuxtApp => {

  return {
    provide: {
      plu: plural,
      amplitude
    }
  }
})
